import { motion, Reveal, easeLuxury } from "../components/motion";
import { useContent } from "../context/SiteContentContext";
import { mediaUrl } from "../lib/api";


export default function GalleryPage() {
  const { get } = useContent();
  const IMAGES = get("gallery.images") || [];
  return (
    <div className="pt-32 pb-24 grain min-h-screen" data-testid="gallery-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <div className="eyebrow">Visual Stories</div>
            <h1 className="font-display text-5xl sm:text-6xl mt-6">{get("gallery.title")}</h1>
            <div className="divider-gold mx-auto" />
            <p className="text-luxury-body">{get("gallery.subtitle")}</p>
          </div>
        </Reveal>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {IMAGES.map((img, i) => (
            <motion.div
              key={i}
              className={`img-zoom break-inside-avoid ${img.h === "tall" ? "h-[560px]" : "h-[380px]"}`}
              data-testid={`gallery-image-${i}`}
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.1, ease: easeLuxury }}
              whileHover={{ scale: 1.02 }}
            >
              <img src={mediaUrl(img.src)} alt={img.caption || `Suite photo ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
